import { Link } from "react-router-dom";
import { clarityMessage, type ResumeClarity } from "@jobreel/shared";
import { T } from "../tokens";

// Encouraging, non-critical résumé-improvement guidance. Renders nothing when the
// résumé is clear (or when clarity is absent — feature gated off server-side), so
// callers can drop it in unconditionally. `to` adds a "Go to Profile →" link on
// pages other than Profile itself (where the user acts on the guidance).
export function ResumeClarityCallout({
  clarity,
  to,
  compact = false,
}: {
  clarity?: ResumeClarity | null | undefined;
  to?: string | undefined;
  compact?: boolean;
}) {
  const msg = clarity ? clarityMessage(clarity.level) : null;
  if (!msg) return null;   // clear résumé, or feature off → say nothing

  return (
    <div
      role="note"
      style={{
        display: "flex", gap: "12px", alignItems: "flex-start",
        padding: compact ? "12px 14px" : "14px 16px",
        marginBottom: "16px",
        background: T.s1,
        border: `1px solid ${T.b1}`,
        borderLeft: `3px solid ${T.info}`,
        borderRadius: "8px",
      }}
    >
      <span aria-hidden style={{
        flexShrink: 0, width: "18px", height: "18px", marginTop: "1px",
        borderRadius: "50%", border: `1.5px solid ${T.info}`, color: T.info,
        fontFamily: T.mono, fontSize: "12px", fontWeight: 700, lineHeight: "15px",
        textAlign: "center",
      }}>i</span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontFamily: T.display, fontSize: "13px", fontWeight: 600, color: T.t0, marginBottom: "3px" }}>
          {msg.headline}
        </div>
        <div style={{ fontFamily: T.body, fontSize: "12.5px", color: T.t1, lineHeight: 1.5 }}>
          {msg.body}
          {to && (
            <>
              {" "}
              <Link to={to} style={{ color: T.info, textDecoration: "none", fontWeight: 500, whiteSpace: "nowrap" }}>
                Choose target role →
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
